import axios from 'axios';

// const BaseURL = 'https://pkubpusat.com:3000'; //PROD
// const BaseURL = 'https://31.220.18.132'; //PROD
const BaseURL = 'https://pkubpusat.kemenag.go.id'; //PROD
// const BaseURL = 'http://80.211.143.7'; //DEV
// const BaseURL = 'https://api.indonesiaharmoni.id'; //PROD domain
// const BaseURL = 'http://localhost:4000';

const API = axios.create({
  baseURL: BaseURL,
  headers: {
    'Cache-Control': 'no-cache'
  }
})

export {
  API, BaseURL
}
